import { Column, COLUMN_NAMES, COLUMN_RESOURCES } from "../../../shared";

export const ANALYSIS_PROVIDER_TABLE_COLUMNS: Column[] = [
  {
    name: COLUMN_NAMES.Name,
    isSticky: true,
    resource: COLUMN_RESOURCES.Name,
    sortResource: COLUMN_RESOURCES.Name,
    isDefaultActive: true,
    isDisabled: true
  },
  {
    name: COLUMN_NAMES.Provider,
    isSticky: false,
    resource: COLUMN_RESOURCES.Provider,
    sortResource: COLUMN_RESOURCES.Provider,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.Company,
    isSticky: false,
    resource: COLUMN_RESOURCES.Company,
    sortResource: COLUMN_RESOURCES.Company,
    isDefaultActive: true,
    isBadge: true
  },
  {
    name: COLUMN_NAMES.Status,
    isSticky: false,
    resource: COLUMN_RESOURCES.Status,
    sortResource: COLUMN_RESOURCES.Status,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.LastEvent,
    isSticky: false,
    resource: COLUMN_RESOURCES.LastEvent,
    sortResource: COLUMN_RESOURCES.LastEvent,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.CreatedAt,
    isSticky: false,
    resource: COLUMN_RESOURCES.CreatedAt,
    sortResource: COLUMN_RESOURCES.CreatedAt,
    isDefaultActive: true
  }
];
